"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.images = exports.icons = exports.cloudFrontUrlAvatars = void 0;
const cloudFront_1 = require("./cloudFront");
const cloudFrontUrlIcons = cloudFront_1.cloudFrontUrl + "icons/";
exports.cloudFrontUrlAvatars = cloudFront_1.cloudFrontUrl + "avatar/";
exports.icons = {
    AccountMenu: cloudFrontUrlIcons + "account-menu.svg",
    AccountMenuActive: cloudFrontUrlIcons + "account-menu-active.svg",
    Add: cloudFrontUrlIcons + "add.svg",
    AppStore: cloudFrontUrlIcons + "app-store-icon.svg",
    GooglePlay: cloudFrontUrlIcons + "google-play-icon.svg",
    AddCircled: cloudFrontUrlIcons + "add-circled.svg",
    AddStopOver: cloudFrontUrlIcons + "add-stopver.svg",
    Airplane: cloudFrontUrlIcons + "airplane.svg",
    AirplaneCircled: cloudFrontUrlIcons + "airplane-circled.svg",
    AirplaneDetail: cloudFrontUrlIcons + "airplane-detail.svg",
    AirplaneTicket: cloudFrontUrlIcons + "airplane-ticket.svg",
    ArrowLeft: cloudFrontUrlIcons + "arrow-left.svg",
    ArrowLeftRate: cloudFrontUrlIcons + "arrow-left-rate.svg",
    ArrowRight: cloudFrontUrlIcons + "arrow-right.svg",
    ArrowRightRate: cloudFrontUrlIcons + "arrow-right-rate.svg",
    BarRightArrow: cloudFrontUrlIcons + "bar-right-arrow.svg",
    Cancel: cloudFrontUrlIcons + "cancel.svg",
    CancelDisabled: cloudFrontUrlIcons + "cancel-disabled.svg",
    Canceled: cloudFrontUrlIcons + "canceled.svg",
    Chat: cloudFrontUrlIcons + "chat.svg",
    Coin: cloudFrontUrlIcons + "coin.svg",
    Completed: cloudFrontUrlIcons + "completed.svg",
    CreditCard: cloudFrontUrlIcons + "credit-card.svg",
    DataProtection: cloudFrontUrlIcons + "data-protection.svg",
    Date: cloudFrontUrlIcons + "date.svg",
    DedicatedDetail: cloudFrontUrlIcons + "dedicated-detail.svg",
    DedicatedFlightCircled: cloudFrontUrlIcons + "dedicated-flight-circled.svg",
    DefaultUser: cloudFrontUrlIcons + "default-user-picture.svg",
    DeleteAccount: cloudFrontUrlIcons + "delete-account.svg",
    DepartureAirport: cloudFrontUrlIcons + "departure-airport.svg",
    DestinationAirport: cloudFrontUrlIcons + "destination-airport2.svg",
    Duration: cloudFrontUrlIcons + "duration.svg",
    Edit: cloudFrontUrlIcons + "edit.svg",
    EditCircled: cloudFrontUrlIcons + "edit-circled.svg",
    Facebook: cloudFrontUrlIcons + "facebook.svg",
    FlightCancelled: cloudFrontUrlIcons + "lot-anulowany-icon.svg",
    FlightCompleted: cloudFrontUrlIcons + "lot-odbyty-icon.svg",
    FlightOffer: cloudFrontUrlIcons + "lot-oferta-iconn.svg",
    GoBack: cloudFrontUrlIcons + "go-back2.svg",
    Google: cloudFrontUrlIcons + "google.svg",
    Help: cloudFrontUrlIcons + "help.svg",
    Instagram: cloudFrontUrlIcons + "instagram.svg",
    IntermediatePoint: cloudFrontUrlIcons + "intermediate-point.svg",
    LetsFlyMenu: cloudFrontUrlIcons + "let's-fly-menu.svg",
    LetsFlyMenuActive: cloudFront_1.cloudFrontUrl + "icons/let's-fly-menu-active.svg",
    LetsFlyMenuActiveMobile: cloudFrontUrlIcons + "let's-fly-menu-active-mobile.svg",
    LetsFlyMenuMobile: cloudFrontUrlIcons + "let's-fly-menu-mobile.svg",
    License: cloudFrontUrlIcons + "license.svg",
    LinkIcon: cloudFrontUrlIcons + "icon-link-blue.svg",
    Location: cloudFrontUrlIcons + "location.svg",
    LogOut: cloudFrontUrlIcons + "logout.svg",
    ManagePaymentMethods: cloudFrontUrlIcons + "manage-payment-methods.svg",
    Message: cloudFrontUrlIcons + "message.svg",
    MessagesIcon: cloudFrontUrlIcons + "no-messages.svg",
    MessagesMenu: cloudFrontUrlIcons + "messages-menu.svg",
    MessagesMenuMobile: cloudFrontUrlIcons + "messages-menu-mobile.svg",
    MessagesMenuActive: cloudFront_1.cloudFrontUrl + "icons/messages-menu-active.svg",
    MessagesMenuActiveMobile: cloudFrontUrlIcons + "messages-menu-active-mobile.svg",
    Music: cloudFrontUrlIcons + "music.svg",
    MyFlightsMenu: cloudFrontUrlIcons + "my-flights-menu.svg",
    MyFlightsMenuMobile: cloudFrontUrlIcons + "my-flights-menu-mobile.svg",
    MyFlightsMenuActive: cloudFront_1.cloudFrontUrl + "icons/my-flights-menu-active.svg",
    MyFlightsMenuActiveMobile: cloudFrontUrlIcons + "my-flights-menu-active-mobile.svg",
    NoChat: cloudFrontUrlIcons + "no-chat.svg",
    NoStopOvers: cloudFrontUrlIcons + "no-stopovers.svg",
    Notifications: cloudFrontUrlIcons + "notifications.svg",
    PassengerDetail: cloudFrontUrlIcons + "passenger-detail.svg",
    Passengers: cloudFrontUrlIcons + "passengers.svg",
    Password: cloudFrontUrlIcons + "password.svg",
    PasswordEye: cloudFrontUrlIcons + "eye.svg",
    PasswordOffEye: cloudFrontUrlIcons + "eye-off.svg",
    Pencil: cloudFrontUrlIcons + "pencil.svg",
    Pilot: cloudFrontUrlIcons + "pilot.svg",
    PriceCircled: cloudFrontUrlIcons + "price-circled.svg",
    PriceDetail: cloudFrontUrlIcons + "price-detail.svg",
    Publish: cloudFrontUrlIcons + "publish.svg",
    PublishActive: cloudFrontUrlIcons + "publish-active.svg",
    PushNotification: cloudFrontUrlIcons + "push-notifications.svg",
    QuestionMark: cloudFrontUrlIcons + "question-mark.svg",
    RatingStar: cloudFrontUrlIcons + "rating-star.svg",
    RatingStarBlue: cloudFrontUrlIcons + "rating-star-blue.svg",
    RatingStarWhite: cloudFrontUrlIcons + "rating-star-white.svg",
    RateModalStar: cloudFrontUrlIcons + "rate-modal-star.svg",
    RateModalStarSelected: cloudFrontUrlIcons + "rate-modal-star-selected.svg",
    Redirector: cloudFrontUrlIcons + "redirector2.svg",
    Report: cloudFrontUrlIcons + "report.svg",
    ReportProblem: cloudFrontUrlIcons + "report-problem.svg",
    Reported: cloudFrontUrlIcons + "reported.svg",
    Search: cloudFrontUrlIcons + "search.svg",
    SearchActive: cloudFrontUrlIcons + "search-active.svg",
    Seats: cloudFrontUrlIcons + "seats.svg",
    SeatsDetail: cloudFrontUrlIcons + "seats-detail.svg",
    SeatsLeftCircled: cloudFrontUrlIcons + "seats-left-circled.svg",
    SendButton: cloudFrontUrlIcons + "send-button.svg",
    Share: cloudFrontUrlIcons + "share.svg",
    ShareLocation: cloudFrontUrlIcons + "share-location.svg",
    SharedFlightCircled: cloudFrontUrlIcons + "shared-flight-circled.svg",
    Star: cloudFrontUrlIcons + "star.svg",
    Stopovers: cloudFrontUrlIcons + "stopovers.svg",
    StopoversCircled: cloudFrontUrlIcons + "stopovers.svg",
    SubtractCircled: cloudFrontUrlIcons + "subtract-circled.svg",
    Success: cloudFrontUrlIcons + "success.svg",
    Swap: cloudFrontUrlIcons + "swap.svg",
    SwapOrder: cloudFrontUrlIcons + "swap-order.svg",
    TermsAndConditions: cloudFrontUrlIcons + "terms-and-conditions.svg",
    Tick: cloudFrontUrlIcons + "tick2.svg",
    TimelineAirplane: cloudFrontUrlIcons + "timeline-airplane2.svg",
    Translate: cloudFrontUrlIcons + "translate.svg",
    Twitter: cloudFrontUrlIcons + "twitter-x-logo-blue.svg",
    Wallet: cloudFrontUrlIcons + "wallet-payment.svg",
    WalletAccount: cloudFrontUrlIcons + "wallet-account.svg",
};
exports.images = {
    cloud: cloudFront_1.cloudFrontUrl + 'cloud-no-plane-high-res.png',
    cockpit: cloudFront_1.cloudFrontUrl + 'cockpit-high-res.png',
    dataProtectionIcon: cloudFront_1.cloudFrontUrl + 'data-protection-icon.png',
    heroImage: cloudFront_1.cloudFrontUrl + 'hero-high-res.png',
    logoHorizontal: cloudFront_1.cloudFrontUrl + 'flyway-logo-horizontal-blue.png',
    logoVertical: cloudFront_1.cloudFrontUrl + 'flyway-vertical-colored-black-text.png',
    pilot: cloudFront_1.cloudFrontUrl + 'pilot-high-res.png',
    planeGround: cloudFront_1.cloudFrontUrl + 'plane-ground-high-res.png',
    welcomePlane: cloudFront_1.cloudFrontUrl + 'welcome-plane.png',
    window: cloudFront_1.cloudFrontUrl + 'window-high-res.png'
};
